/**
 * Recently Viewed Products Carousel
 * Displays products the user has recently viewed
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../../../components/styled/Card';
import { PrimaryButton } from '../../../components/styled/Button';
import recentlyViewedService from '../services/recentlyViewedService';
import { useCart } from '../contexts/CartContext';
import useShopFeatures from '../hooks/useShopFeatures';
import { formatPrice } from '../utils/productHelpers';
import '../pages/Shop.css';

const RecentlyViewed = ({ excludeProductId }) => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const { addItem: addToCart } = useCart();
  const features = useShopFeatures();

  useEffect(() => {
    loadRecentlyViewed();
  }, [excludeProductId]);

  const loadRecentlyViewed = () => {
    let viewed = recentlyViewedService.getProducts();
    
    // Exclude current product if specified
    if (excludeProductId) {
      viewed = viewed.filter(p => p.id !== excludeProductId);
    }
    
    setProducts(viewed.slice(0, 6)); // Show max 6 items
  };

  if (!features.recentlyViewed || products.length === 0) {
    return null;
  }

  return (
    <div className="recently-viewed-section">
      <h2>Recently Viewed</h2>
      <div className="recently-viewed-carousel">
        {products.map((product) => (
          <Card 
            key={product.id} 
            className="recently-viewed-card"
            onClick={() => navigate(`/shop/product/${product.id}`)}
          >
            <div className="product-image-container">
              <img src={product.image} alt={product.name} className="product-image" />
            </div>
            <CardContent>
              <h4 className="product-name">{product.name}</h4>
              <p className="price">${formatPrice(product.price)}</p>
              <PrimaryButton 
                onClick={(e) => {
                  e.stopPropagation();
                  addToCart(product);
                  alert(`Added ${product.name} to cart!`);
                }}
                size="small"
                style={{ width: '100%', marginTop: '8px' }}
              >
                Add to Cart
              </PrimaryButton>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default RecentlyViewed;

